module.exports = __webpack_public_path__ + "static/img/szrlb.248bf64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szrlb.jpg
// module id = UX7S
// module chunks = 73